import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { checkParams } from "../../../src/util/Util";
import "./SignUpFlow.css";
import { Context } from "../../context/Context";

const SignUpFlow = () => {
  const { clearAllData } = useContext(Context);
  const [validToProceed, setValidToProceed] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [adultError, setIsAdultError] = useState("");
  const [isAdult, setIsAdult] = useState(true);
  const [errorFirstName, setErrorFirstName] = useState("");
  const [errorLastName, setErrorLastName] = useState("");
  const [noSuchUser, setNoSuchUser] = useState(false);
  const [userAlreadyReg, setUserAlreadyReg] = useState(false);
  let navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const isSelfAssessment = params.get("self-assessment") === "true";

    if (isSelfAssessment) {
      navigate("/register" + location.search, { replace: true });
    }
  }, [location, navigate]);

  useEffect(() => {
    clearAllData();
  }, []);

  const [companyNameTitle, setCompanyNameTitle] = useState(
    document.location.search == "?wantz"
      ? "Wantz Distributors"
      : "Virdio Health Live"
  );

  const handleBirthday = (value) => {
    setUserAlreadyReg(false);
    setNoSuchUser(false);
    var strippedValue = value;

    if (
      strippedValue !== "" &&
      /^((0?[1-9]|1[012])[- /.](0?[1-9]|[12][0-9]|3[01])[- /.](19|20)?[0-9]{4})*$/.test(
        strippedValue
      )
    ) {
      // valid date, check for missing zeros
      strippedValue = strippedValue.split("/");
      if (strippedValue[0].length === 1) {
        strippedValue[0] = "0" + strippedValue[0];
      }
      if (strippedValue[1].length === 1) {
        strippedValue[1] = "0" + strippedValue[1];
      }
      strippedValue = strippedValue.join("");
    }
    // eslint-disable-next-line
    if (/[\/]/.test(strippedValue)) {
      strippedValue = strippedValue.split("/");
      strippedValue = strippedValue.join("");
    }
    // eslint-disable-next-line
    if (/[\.]/.test(strippedValue)) {
      strippedValue = strippedValue.split(".");
      strippedValue = strippedValue.join("");
    }

    if (!!testDateValidity(strippedValue) === true) {
      if (adultError) {
        setIsAdultError("");
      }
      setDateOfBirth(testDateValidity(strippedValue));
    } else {
      setDateOfBirth(value);
      if (!adultError) {
        setIsAdultError("User have to be over 18 to proceed.");
      }
    }
  };

  const testDateValidity = (opt) => {
    let reg = /^(?:(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])(19|20)[0-9]{2})$/;

    if (reg.test(opt)) {
      var fixedOpt = opt.replace(
        reg,
        "$1/$2/$3" + opt[opt.length - 2] + opt[opt.length - 1]
      );
      const nowYear = new Date().getFullYear();
      let yearToCompare = fixedOpt.split("/");
      let isAdultValidation = parseInt(nowYear) - parseInt(yearToCompare[2]);
      if (isAdultValidation < 18) {
        return false;
      }
      return fixedOpt;
    } else {
      return false;
    }
  };

  const handleFirstName = (value) => {
    setUserAlreadyReg(false);
    setNoSuchUser(false);
    value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    setFirstName(value);
    if (!checkParams(value, "firstname")) {
      setErrorFirstName("Please enter a valid name.");
    } else {
      setErrorFirstName("");
    }
  };

  const handleLastName = (value) => {
    setUserAlreadyReg(false);
    setNoSuchUser(false);
    value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    setLastName(value);
    if (!checkParams(value, "lastname")) {
      setErrorLastName("Please enter a valid last name.");
    } else {
      setErrorLastName("");
    }
  };

  // eslint-disable-next-line
  const handleAgeValidation = (dateOpt) => {
    let currentYear = new Date().getFullYear();
    let dateArr = dateOpt.split("/");
    let yearOfBirth = parseInt(dateArr[2]);
    let checkIsAdult = currentYear - yearOfBirth;
    let adultVar = true;
    let errorMessage = "";
    if (checkIsAdult < 18) {
      adultVar = false;
      errorMessage = "You have to be over 18 to proceed.";
    } else {
      adultVar = true;
    }
    setIsAdult(adultVar);
    setIsAdultError(errorMessage);
    return adultVar;
  };

  const proceedToNextStep = async (step) => {
    if (step === 1) {
      await axios
        .post(window.ajaxLink + "user/checkForUserCompany", {
          firstName,
          lastName,
          dateOfBirth,
        })
        .then((res) => {
          if (res.data.responseData) {
            if (res.data.responseCode === 200) {
              setNoSuchUser(false);
              setUserAlreadyReg(false);
              localStorage.setItem(
                "userCompanyData",
                JSON.stringify(res.data.responseData)
              );
              localStorage.setItem(
                "userMainTherapist",
                JSON.stringify(res.data.responseData[0].therapist_id)
              );

              navigate(
                "/register" +
                  (res.data.responseData[0].company["business_id"] === 1
                    ? "?1"
                    : "")
              );
            }
          }
        })
        .catch((error) => {
          if (error.response.data.errorData === "no user found") {
            setNoSuchUser(true);
            setUserAlreadyReg(false);
          } else if (
            error.response.data.errorData === "user already registered"
          ) {
            setUserAlreadyReg(true);
            setNoSuchUser(false);
          }
          console.error(error);
        });
    }
  };

  const proceedToLoginPage = () => {
    navigate("/login");
  };

  useEffect(() => {
    if (
      dateOfBirth.length > 9 &&
      adultError === "" &&
      isAdult === true &&
      firstName.length >= 2 &&
      lastName.length >= 2 &&
      errorFirstName === "" &&
      errorLastName === ""
    ) {
      setValidToProceed(true);
    } else {
      setValidToProceed(false);
    }
  }, [
    adultError,
    dateOfBirth.length,
    errorFirstName,
    errorLastName,
    firstName.length,
    isAdult,
    lastName.length,
  ]);

  return (
    <>
      <div className="signup_full_background">
        <div className="signup_logo_img_header signup_upper_logo next_step_logo"></div>
        <div className="we_can_help_txt">
          Find relief from physical pain in a fun engaging way.
        </div>
        <div className="signup_image"></div>
        <div className="main_signup_container">
          <>
            <div>
              <div className="head_container_next_step">
                <div className="next_step_img"></div>
                {/* <div className="divider"></div> */}
                {/* <div className="organization_name">{companyNameTitle}</div> */}
              </div>
            </div>
            <div
              style={{ marginTop: "0px" }}
              className="main_components find_out_txt"
            >
              Ready to Get Started
            </div>
            <div
              style={{ width: "100%", textAlign: "center" }}
              className="main_components find_out_txt_scnd"
            >
              We’ll check if Virdio Health is offered by your company
            </div>
            <div className="infos_holder">
              <div className="form_details">Legal First name</div>
              <div
                className={
                  errorFirstName.length > 0
                    ? "main_components_error"
                    : "main_components"
                }
              >
                <input
                  type="text"
                  placeholder="Enter First Name"
                  className={
                    firstName && firstName.length > 0
                      ? "form_input_border"
                      : "form_input"
                  }
                  onChange={(e) => handleFirstName(e.currentTarget.value)}
                  value={firstName && firstName.length > 0 ? firstName : ""}
                  maxLength={50}
                />
              </div>
              {errorFirstName && (
                <div className="signup_error_msg">{errorFirstName}</div>
              )}
              <div className="form_details">Last name</div>
              <div
                className={
                  errorLastName.length > 0
                    ? "main_components_error"
                    : "main_components"
                }
              >
                <input
                  type="text"
                  placeholder="Enter Last Name"
                  className={
                    lastName && lastName.length > 0
                      ? "form_input_border"
                      : "form_input"
                  }
                  onChange={(e) => handleLastName(e.currentTarget.value)}
                  value={lastName && lastName.length > 0 ? lastName : ""}
                  maxLength={50}
                />
              </div>
              {errorLastName && (
                <div className="signup_error_msg">{errorLastName}</div>
              )}
              <div className="form_details">Date of Birth</div>
              <div
                className={
                  adultError ? "main_components_error" : "main_components"
                }
              >
                <input
                  type="text"
                  placeholder="MM/DD/YYYY"
                  className={
                    dateOfBirth && dateOfBirth.length > 0
                      ? "form_input_border"
                      : "form_input"
                  }
                  onChange={(e) => handleBirthday(e.currentTarget.value)}
                  value={
                    dateOfBirth && dateOfBirth.length > 0 ? dateOfBirth : ""
                  }
                  maxLength={10}
                />
              </div>
              {adultError && (
                <div className="signup_error_msg">{adultError}</div>
              )}
              {noSuchUser && (
                <div className="no_such_user_error">
                  We could not verify your eligibility. Please check your
                  personal information again or contact your employer or
                  practitioner or contact support@virdiohealth.com
                </div>
              )}
              {userAlreadyReg && (
                <div
                  style={{ lineHeight: "20px" }}
                  className="no_such_user_error"
                >
                  User already registered, try login instead.
                </div>
              )}
            </div>
            <div
              className={
                "get_started_sign_up" +
                (!validToProceed ? " reg_procc_disabled" : "")
              }
              onClick={() => validToProceed && proceedToNextStep(1)}
            >
              Get Started
            </div>
            <div
              style={{ marginTop: "32px" }}
              className="other_components_bottom"
            >
              Already have an account?
            </div>
            <div
              style={{ textDecoration: "none" }}
              className="other_components_bottom link_components login_link"
              onClick={() => proceedToLoginPage()}
            >
              Log in
            </div>
            <div className="other_components_bottom">Questions?</div>
            <div className="other_components_bottom link_components">
              support@virdiohealth.com
            </div>
            <div className="other_components_bottom link_components">
              Help Center
            </div>
            <div className="question_mark_holder">
              <div className="question_mark"></div>
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default SignUpFlow;
